import { createStyle } from "~/common/utils/create-style";

const dialogStyle = createStyle({
  slots: {
    dialog:
      "fixed inset-0 z-1000 flex size-full flex-col items-center justify-center outline-hidden",
    container: [
      "flex h-screen w-full flex-col bg-surface-on-light-20",
      "sm:size-auto sm:rounded-xl sm:max-w-[58rem]",
      "text-text-primary-on-light",
    ],
    header:
      "flex flex-row justify-between border-b border-b-gray-solid-200 p-16",
    heading: "text-title-5 self-center",
    closeButton: "text-black cursor-pointer",
    content: "p-16",
    footer:
      "flex flex-row border-t border-t-gray-solid-200 p-16 justify-end gap-8",
    button: "cursor-pointer",
  },
  variants: {
    variant: {
      default: "",
      full: { button: "grow" },
    },
  },
})();

export { dialogStyle };
